export default [{
  path: '/organization',
  name: 'organization',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/organization/index')
}]
